import { pgTable, varchar, text, timestamp, numeric, boolean, primaryKey, index, check } from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

const scope = () => ({
  brandId: varchar("brand_id").notNull(), accountId: varchar("account_id", { length: 128 }).notNull(),
  revision: varchar("revision").notNull(), locationId: varchar("location_id", { length: 128 }).notNull(),
});
export const squareOrders = pgTable("square_orders", {
  ...scope(), orderId: varchar("order_id", { length: 128 }).notNull(),
  state: text("state").notNull(), createdAt: timestamp("created_at", { withTimezone: true }).notNull(),
  localDay: varchar("local_day", { length: 10 }).notNull(), currency: varchar("currency", { length: 3 }).notNull(),
  timezone: text("timezone").notNull(), orderTotalCents: numeric("order_total_cents", { precision: 24, scale: 0 }).notNull(),
  itemDetailsComplete: boolean("item_details_complete").notNull(),
  syncedAt: timestamp("synced_at", { withTimezone: true }).notNull().defaultNow(),
}, t => [
  primaryKey({ columns: [t.brandId, t.accountId, t.revision, t.orderId] }),
  index("square_orders_range_idx").on(t.brandId, t.accountId, t.revision, t.locationId, t.localDay),
  check("square_orders_completed_check", sql`${t.state} = 'COMPLETED'`),
]);
export const squareOrderLineItems = pgTable("square_order_line_items", {
  ...scope(), orderId: varchar("order_id", { length: 128 }).notNull(), lineItemUid: varchar("line_item_uid", { length: 128 }).notNull(),
  name: text("name").notNull(), variationName: text("variation_name").notNull(),
  catalogObjectId: text("catalog_object_id"), itemType: text("item_type"),
  quantity: numeric("quantity", { precision: 38, scale: 18 }).notNull(),
  grossCents: numeric("gross_cents", { precision: 24, scale: 0 }).notNull(),
  discountCents: numeric("discount_cents", { precision: 24, scale: 0 }).notNull(),
  taxCents: numeric("tax_cents", { precision: 24, scale: 0 }).notNull(),
  totalCents: numeric("total_cents", { precision: 24, scale: 0 }).notNull(),
  orderCreatedAt: timestamp("order_created_at", { withTimezone: true }).notNull(),
  syncedAt: timestamp("synced_at", { withTimezone: true }).notNull().defaultNow(),
}, t => [primaryKey({ columns: [t.brandId, t.accountId, t.revision, t.orderId, t.lineItemUid] })]);
export const squarePurchasesDays = pgTable("square_purchases_days", {
  ...scope(), day: varchar("day", { length: 10 }).notNull(), status: text("status").notNull(),
  itemDetailsComplete: boolean("item_details_complete").notNull().default(false),
  limitation: text("limitation"), refreshedAt: timestamp("refreshed_at", { withTimezone: true }).notNull().defaultNow(),
}, t => [primaryKey({ columns: [t.brandId, t.accountId, t.revision, t.locationId, t.day] })]);
